import React, { Component, useState, useEffect } from 'react';
import BlogEntrance from './BlogEntrance';
import BlogOtherEntries from './BlogOtherEntries';
import LaravelApi from '../laravelApi/LaravelApi';
import Spinner from '../spinner/Spinner';

const Blog = () => {
  const [blogId, setBlogId] = useState(null);
  const [blogData, setBlogData] = useState(null);
  const [otherEntries, setOtherEntries] = useState(null);

  useEffect(() => {
    fetchLatestBlog();
    fetchOtherEntries();
  }, [blogId]);

  const fetchLatestBlog = async () => {
    var response = null;
    if (blogId != null) {
      response = await LaravelApi.get('/blog/'+blogId, {});
    } else {
      response = await LaravelApi.get('/blog/latest', {});
    }

    setBlogId(response.data.id);
    setBlogData(response.data); 
  }

  const fetchOtherEntries = async () => {
    const response = await LaravelApi.get('/blog/', {});
    setOtherEntries(response.data);
  }

  const handleEntryChange = (event) => {
    if (typeof(event) != 'undefined') {
      const target = event.target;
      const value = target.value;
      setBlogId(value);
    } 
  }

  if (blogId == null || otherEntries == null || blogData == null) {
    return <Spinner />;
  }

  return (
    <div className="ui segment">
      <div className="ui internally stackable grid">
        <div className="row">
          <div className="three wide column"> 
          </div>
          <div className="three wide column">
          </div>
        </div>
        <div className="row">
          <div className="three wide column">
          </div>
          <div className="ten wide column">
            <BlogEntrance blogData={blogData} />          
          </div>
          <div className="three wide column">
            <div className="ui container"> 
              <BlogOtherEntries entries={otherEntries} onEntryChange={handleEntryChange} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Blog;
